var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.225,
    height: 312.808,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6257.43 2747.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10.63,
    rx: 10.63,
    width: 223.228,
    height: 311.811,
    x: 6257.929,
    y: -2746.811,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.997
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6347.418-2689.863c9.92-9.682 16.436-20.237 22.667-30.39 5.464 11.171 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.918-6.268-10.796-12.866-20.572-22.694-29.918zM6347.418-2491.055c9.92-9.682 16.436-20.237 22.667-30.39 5.464 11.171 13.306 20.943 21.786 30.39-9.073 9.368-16.105 19.386-21.759 29.918-6.268-10.796-12.866-20.572-22.694-29.918zM6454.437-2497.711c4.063-3.966 6.732-8.29 9.285-12.449 2.238 4.576 5.45 8.579 8.925 12.449-3.717 3.837-6.598 7.941-8.914 12.255-2.567-4.422-5.27-8.427-9.296-12.255zM6266.713-2683.983c4.064-3.966 6.733-8.29 9.285-12.449 2.239 4.576 5.45 8.58 8.925 12.449-3.717 3.838-6.598 7.941-8.914 12.256-2.567-4.423-5.27-8.427-9.296-12.256zM6266.24-2700.174l.164-2.019c.51-6.239 1.874-8.346 9.622-14.855 3.76-3.159 4.994-4.718 5.168-6.526.49-4.26-3.351-5.591-5.855-5.614-3.242-.03-6.91 1.911-5.161 6.414l-3.637 1.068c-.734-4.2.017-8.142 3.426-9.893 4.546-2.28 10.38-1.385 13.323 2.207 1.978 2.414 2.428 5.746 1.368 8.356-3.1 6.671-13.621 9.606-14.49 17.319h11.63v-4.295h3.426v7.907zM6472.848-2481.637l-.165 2.019c-.51 6.239-1.875 8.346-9.622 14.855-3.76 3.159-4.994 4.717-5.168 6.526-.49 4.26 3.351 5.591 5.855 5.614 3.242.03 6.91-1.911 5.161-6.414l3.637-1.068c.734 4.2-.017 8.142-3.426 9.893-4.546 2.28-10.38 1.385-13.323-2.207-1.978-2.414-2.428-5.746-1.368-8.356 3.1-6.671 13.621-9.606 14.49-17.32h-11.63v4.296h-3.426v-7.907z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2D.9f8af32091b32af42b089b08a9468be8.svg";
export { ForwardRef as ReactComponent };